export const START_RIPRISTINA_DEFAULTS = 'START_RIPRISTINA_DEFAULTS';

/**
 * Get persona telefoni.
 * @function startRipristinaDefaults
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function startRipristinaDefaults(path, data, subrequest, page) {
  return {
    type: START_RIPRISTINA_DEFAULTS,
    path,
    request: {
      op: 'get',
      path: `${path}/@ripristinaDefaults`,
    },
  };
}
